<template>
    <div class="mobile-404">
        <div class="illustration" aria-hidden="true">
           <!-- <img class="logo" src="/images/logo.png"/> -->
            <div class="bigcode" aria-hidden="true">404</div>
        </div>
        <h1 v-if="false">页面未找到</h1>
        <p v-if="false" class="lead">抱歉，我们找不到你访问的页面。</p>
        <p v-if="false" class="hint">也可以检查一下 URL 是否输入正确，或联系网站管理员。</p>
    </div>
</template>

<script>
export default {
    name: 'Mobile404'
}
</script>

<style scoped>
.mobile-404 {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 100vh;
    text-align: center;
    padding: 16px;
    box-sizing: border-box;
    background: linear-gradient(180deg, #b9ddf2 0%, #eaf6fc 100%);
    color: #243b53;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial;
}

.illustration {
    width: 120px;
    height: 120px;
    margin-bottom: 12px;
    background: radial-gradient(circle at 30% 30%, rgba(185, 221, 242, 0.35), transparent 20%), linear-gradient(180deg, rgba(185, 221, 242, 0.2), transparent 50%);
    border-radius: 16px;
    padding: 12px;
    box-sizing: border-box;
    backdrop-filter: blur(6px);
    -webkit-backdrop-filter: blur(6px);
    animation: floaty 3.8s ease-in-out infinite;
}
/* .logo{
    width: 120px;
    height: 120px;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    border-radius: 50%;
} */

.bigcode {
    font-weight: 700;
    font-size: 48px;
    letter-spacing: -0.03em;
    margin: 4px 0;
    color: #FFF;
}

h1 {
    font-size: 20px;
    margin: 6px 0 4px;
    letter-spacing: -0.02em;
}

.lead {
    color: #6b7a86;
    margin: 0 0 8px;
    font-size: 13px;
}

.hint {
    font-size: 12px;
    color: #6b7a86;
    margin-top: 6px;
}

@keyframes floaty {
    0% {
        transform: translateY(0)
    }

    50% {
        transform: translateY(-6px)
    }

    100% {
        transform: translateY(0)
    }
}
</style>
